import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from '../../services/translation';

export default class PrintFavourites extends Component {

    static propTypes = {
        printBaseUrl: PropTypes.string,
        printUrl: PropTypes.string,
        itineraryIds: PropTypes.string,
        excursionIds: PropTypes.string
    };

    downloadPdf = () => {
        const {printBaseUrl, printUrl, itineraryIds, excursionIds} = this.props;

        const queryString = [
            itineraryIds ? 'itineraryIds=' + itineraryIds : '',
            excursionIds ? 'excursionIds=' + excursionIds : ''
        ].filter(Boolean).join('&');

        const innerUrl = printUrl + (printUrl.includes('?') ? '&' : '?') + queryString;

        let link = document.createElement('a');
        link.href = printBaseUrl + '?tx_nezzoprojecttemplate_gotenberg[url]=' +
            encodeURIComponent(innerUrl) +
            '&filename=' + translate('itinerary_favourites.print_filename');

        link.target = '_blank';
        link.rel = 'noopener noreferrer';

        link.dispatchEvent(new MouseEvent('click'));
    };

    render() {
        const {itineraryIds, excursionIds} = this.props;

        if (!itineraryIds && !excursionIds) {
            return null;
        }

        return (
            <div className='printFavouritesContainer'>
                <button onClick={this.downloadPdf}>
                    {translate('itinerary_favourites.print_button')}
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Favourites/PrintFavourites.js